import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Empty from '../../template/UtilTemplate/Empty';
import CustomerService from './customerService';
import WebViewHeader from '../../template/WebViewHeader/WebViewHeader';
import UA from '../../utils/ua';
import { COURSE_URL } from '../../constants';
import { parseQuery } from '../../utils/tools';
import AXIOS from '../../api/axios';

import './style.less';
import clientApi from '../../api/client';


class FeedbackPage extends Component {
    constructor(props){
        super(props);
        this.isMobile = UA.mobileClient;
        this.queryObj = parseQuery(window.location.search.slice(1));
        this.state = {
            list: []
        };
    }

    componentWillMount(){
        // 获取问题列表
        AXIOS.getFeedBackList({
            data: {
                type: 0
            }
        }, (res,err) => {
            if(err) console.log(err);
            else{
                this.setState({ 
                    list: res
                 });
            }
        })
    }
    // 根据id进入问题详情
    toDetail = (id) => {
        const { history } = this.props;
        let eventType = this.isMobile ? 'c2_app_My_Help_Question' : 'c2_app_Home_Settings_Help_Question';
        clientApi.eventTracking({
            eventType,
            questionId: id
        })            
        history.push({
            pathname: `${COURSE_URL}/feedback/${id}`,
            search:window.location.search,
        });
    }
    render(){
        const { list } = this.state;
        const { yange } = this.queryObj; // yange = 1 苹果审核期间不显示二维码
        const listItem = list.map((ele, index) => {
            return (
                <li 
                    key={index}
                    onClick={() => {this.toDetail(ele.id)}}
                >
                    <div className="text">{ ele.title }</div>
                    <div className="go"></div>
                </li>
            )
        })
        if(this.isMobile){
            return (
                <DocumentTitle title={'帮助与反馈'}>
                    <React.Fragment>
                        <div className={`content-wrap mobile`}>
                            {list.length ?
                                <div className={`container feedback-list`}>
                                    <div className="ul-wrap">
                                        <ul>{ listItem }</ul>
                                    </div>
                                    <div className="tips">——没找到需要的? 试试直接咨询小助手——</div>
                                </div>
                                : <Empty text="暂无数据!" />
                            }
                            <CustomerService isMobile={this.isMobile} oringin="feedback_list" />
                        </div>
                    </React.Fragment>
                </DocumentTitle>
            )
        }
        return(
            <DocumentTitle title={'帮助与反馈'}>
                <React.Fragment>
                    <WebViewHeader showBack={ false } showClose={ false } title="帮助与反馈" />
                    <div className={`content-wrap pc`}>
                        <div className="list__header">常见问题</div>
                        <div className={`container feedback-list`}>
                            <div className="ul-wrap">
                                <ul>{ listItem }</ul>
                            </div>
                            { yange !== '1' && <CustomerService isMobile={this.isMobile} oringin="feedback_list" /> }
                        </div>
                    </div>
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default FeedbackPage;



// WEBPACK FOOTER //
// ./src/components/feedbackPage/feedbackPage.jsx